<template>
	<div class="wrapper">
		<!-- <side-bar>
			<sidebar-link to="/dashboard">
				<md-icon>dashboard</md-icon>
				<p><b>Dashboard</b></p>
			</sidebar-link>
			<sidebar-link to="/new_data">
				<md-icon>add_box</md-icon>
				<p><b>New Data</b></p>
			</sidebar-link>
			<sidebar-link to="/data">
				<md-icon>storage</md-icon>
				<p><b>All Data</b></p>
			</sidebar-link>
			<sidebar-link to="/reports">
				<md-icon>person_search</md-icon>
				<p>ស្វែងរកទិន្នន័យ</p>
			</sidebar-link>
			<sidebar-link to="/reports">
				<md-icon>assessment</md-icon>
				<p><b>Reports</b></p>
			</sidebar-link>
			<sidebar-link to="/settings" v-if="$store.state.authentication.accountType == 'sa'">
				<md-icon>settings</md-icon>
				<p>ការកំណត់ផ្សេងៗ</p>
			</sidebar-link>
			<sidebar-link to="/administrators" v-if="$store.state.authentication.accountType == 'sa'">
				<md-icon>supervised_user_circle</md-icon>
				<p><b>Administrators</b></p>
			</sidebar-link>
		</side-bar> -->
		<top-navbar></top-navbar>

		<dashboard-content>

		</dashboard-content>
		<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		<!-- <div class="main-panel">



		</div> -->
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue